var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFashion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uas0if6rea"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6448",
    style: {
      fill: "none",
      stroke: "#ff731d",
      strokeWidth: "2.5px"
    },
    d: "M0 0h36v36H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2210",
    transform: "translate(-519 -336)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 41",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(519 336)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2202"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2201",
    style: {
      clipPath: "url(#uas0if6rea)"
    },
    transform: "translate(532 347)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 935",
    d: "M23.7 4.13 21.348 1l-3.13 3.913 2.348 3.13L23.7 4.13a9.938 9.938 0 0 1 7.043 2.348l4.7 7.043-5.478 3.913-2.356-3.134v21.13H8.826V14.3l-2.348 3.13L1 13.522l4.7-7.044s1.887-2.543 7.039-2.348",
    transform: "translate(-.217 -.217)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#ff731d",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 936",
    d: "m21.478 4.913-2.348 3.13L16 4.13 18.348 1l3.13 3.913V14.3",
    transform: "translate(-3.478 -.217)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#ff731d",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 26",
    transform: "translate(14.87 .783)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#ff731d",
      strokeWidth: "2.5px"
    },
    d: "M0 0h6.261"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 27",
    transform: "translate(20.348 10.957)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#ff731d",
      strokeWidth: "2.5px"
    },
    d: "M0 0h4.696"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFashion);
export default __webpack_public_path__ + "static/media/icon-fashion.6f35d23a.svg";
export { ForwardRef as ReactComponent };